// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR")
    });
}

import './css/styles.css'


// JS
//import "./js/index.js"

import Alpine from 'alpinejs'

window.Alpine = Alpine
Alpine.start()

window.exampleAlert = () => alert('DDEV + Vite + Tailwind + Alpine are wired up!')

// Sticky logo functionality
document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.header');
    const body = document.body;
    
    if (header) {
        let ticking = false;
        
        function updateHeader() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            
            if (scrollTop > 50) {
                body.classList.add('scrolled');
            } else {
                body.classList.remove('scrolled');
            }
            
            ticking = false;
        }
        
        function requestTick() {
            if (!ticking) {
                requestAnimationFrame(updateHeader);
                ticking = true;
            }
        }
        
        window.addEventListener('scroll', requestTick, { passive: true });
    }
});

// Scroll to top functionality
document.addEventListener('DOMContentLoaded', function() {
    const scrollToTopBtn = document.querySelector('[data-scroll-to-top]');
    
    if (scrollToTopBtn) {
        let ticking = false;
        
        function updateScrollToTop() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            
            // Show button after scrolling 300px
            if (scrollTop > 300) {
                scrollToTopBtn.classList.add('is-visible');
            } else {
                scrollToTopBtn.classList.remove('is-visible');
            }
            
            ticking = false;
        }
        
        function requestScrollTick() {
            if (!ticking) {
                requestAnimationFrame(updateScrollToTop);
                ticking = true;
            }
        }
        
        // Handle scroll detection
        window.addEventListener('scroll', requestScrollTick, { passive: true });
        
        // Handle click to scroll to top
        scrollToTopBtn.addEventListener('click', function(e) {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
});
